import { ChangeParams, InputSwitch } from "primereact/inputswitch"
import React from "react"
import "./selectorStyles.css"

type ShowOnlyOnlineUsersSelectorProps = {
  showOnlyOnlineUsers: boolean
  onChange: (e: ChangeParams) => void
}
export function ShowOnlyOnlineUsersSelector(
  props: ShowOnlyOnlineUsersSelectorProps
): JSX.Element {
  const { showOnlyOnlineUsers, onChange } = props
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        marginBottom: "8px",
      }}
    >
      <p className="mb-0">Todos</p>
      <InputSwitch
        checked={showOnlyOnlineUsers}
        onChange={onChange}
        style={{
          maxHeight: "24px",
          maxWidth: "50px",
        }}
      />
      <p className="mb-0">Online</p>
    </div>
  )
}
